module.exports = __webpack_public_path__ + "img/riointbig7.e7bfe944.png";